<template>
  <FrameDesktopComponent v-if="$isElectron" />
  <HeaderView
    :is-logged="getMetaValue('header', 'isLogged')"
    :style="getMetaValue('header', 'style')"
    :class="$isElectron ? 'electron' : ''"
  />
  <section>
    <MenuView
      :is-logged="getMetaValue('header', 'isLogged')"
      :class="$isElectron ? 'electron' : ''"
    />
    <div class="content-section" :class="$isElectron ? 'electron' : ''">
      <main>
        <router-view />
      </main>
      <!-- <FooterView
        :style="getMetaValue('footer', 'style')"
      /> -->
    </div>
  </section>
  <ToolTip></ToolTip>
</template>

<script>
import HeaderView from "@/views/HeaderView.vue";
// import FooterView from "@/views/FooterView.vue";
import MenuView from "@/views/MenuView.vue";
import FrameDesktopComponent from "@/components/desktop/FrameDesktopComponent.vue";

export default {
  components: {
    HeaderView,
    // FooterView,
    MenuView,
    FrameDesktopComponent,
  },
  mounted() {
    const bodyStyle = this.getMetaValue('body', 'style');
    if (bodyStyle) {
      const bodyClasses = bodyStyle.split(' ');
      document.body.classList.add(...bodyClasses);
    }
  },
  methods: {
    getMetaValue(section, key) {
      return this.$route.meta[section]?.[key];
    },
  },
};
</script>
